export default {
  // TODO eventBus 키 정의
  FETCH_BRAND_INFO: 'fetch-brand-info',
  SHOW_KAKAO_CHANNEL_INFO_DIALOG: 'show-kakao-channel-info-dialog',
  ADD_IMAGE_TEMPLATE: 'add-image-template',
  OPEN_ADD_IMAGE_DIALOG: 'open-add-image-dialog',
  CLEAR_TEMPLATE_VIEW: 'clear-template-view',
  FETCH_TEMPLATE_INFO: 'fetch-template-info',
  SHOW_KAKAO_BRAND_TALK_TEMPLATE_INFO_DIALOG: 'show-kakao-brand-talk-template-info-dialog',
  SHOW_KAKAO_BRAND_TALK_CHANNEL_INFO_DIALOG: 'show-kakao-brand-talk-channel-info-dialog',
  UPDATE_CHAT_ROOM_INPUT: 'update-chat-room-input'
}



// WEBPACK FOOTER //
// ./src/constants/eventType.js